/**
 * The default maximum amount of time to wait between fetch retries, in
 * milliseconds.
 */
export const DEFAULT_MAXIMUM_RETRY_DELAY = 30000;
